import { useLayoutEffect, useRef } from 'react'

import { useGSAP } from '@/composables/useGSAP'

export type IntroEnterSwirlProps = {
  className?: string
}

export default function IntroEnterSwirl({ className }: IntroEnterSwirlProps) {
  const { gsap } = useGSAP()

  const pathOut1Ref = useRef<SVGPathElement>(null)
  const pathOut2Ref = useRef<SVGPathElement>(null)

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap
        .timeline()
        .addLabel('path', 0)
        .fromTo(
          [pathOut1Ref.current, pathOut2Ref.current],
          {
            drawSVG: '0% 0%',
          },
          {
            drawSVG: '0% 100%',
            duration: 0.5,
            stagger: 0.15,
            ease: 'power1.in',
          },
          'path'
        )
        .to(
          [pathOut2Ref.current, pathOut1Ref.current],
          {
            drawSVG: '100% 100%',
            duration: 0.5,
            stagger: 0.15,
            ease: 'power1.inOut',
          },
          'path+=0.65'
        )
    })

    return () => ctx.kill()
  }, [pathOut1Ref, pathOut2Ref, gsap])

  return (
    <div aria-hidden className={`${className ? className : ''}`}>
      <svg
        className={`absolute top-1/2 -translate-y-1/2 left-0 w-[41.111vw]`}
        viewBox='0 0 592 844'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          ref={pathOut1Ref}
          d='M-0.5 642.5C20.8333 652.333 72.5001 660.023 109 612.5C258 418.5 -48 517.261 114.5 626.5C264 727 294.5 489.5 418.5 461.5'
          stroke='black'
          strokeWidth='1.5'
          className='opacity-30'
        />
        <path
          ref={pathOut2Ref}
          d='M-0.5 642.5C20.8333 652.333 72.5001 660.023 109 612.5C258 418.5 -48 517.261 114.5 626.5C264 727 294.5 489.5 418.5 461.5'
          stroke='black'
          strokeWidth='1.5'
          className='opacity-100'
        />
      </svg>
    </div>
  )
}
